module.exports = __webpack_public_path__ + "assets/img/等待送达RAKUMART.090aa7b5.svg";